import {
  Autocomplete,
  TextField
} from '@mui/material/';
import React, { useContext, useEffect, useState } from 'react';
import '../App.css';
import BoxPlot from './BoxPlot';
import Histogram from './Histogram';
import StripPlot from './StripPlot';
import ViolinPlot from './ViolinPLot';
import { SystemContext } from '../context';

const UnivariateAnalysisGraph = ({ fetchAPI }) => {
  const { fileName, numericalColumns, rawOrCleanData, setRawOrCleanData, numericalCleanedCols, actualFileName } = useContext(SystemContext);
  const [allGraphs, setAllGraphs] = useState(["Histogram", "Strip Plot", "Violin Plot", "Box Plot"]);
  const [selectedGraph, setSelectedGraph] = useState('');
  const [selectedColumn, setSelectedColumn] = useState('');
  const [selectedColumnData, setSelectedColumnData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(()=>{
    setSelectedColumn('');
    setSelectedColumnData([]);
  },[rawOrCleanData]);

  const handleGraphSelection = (evt, value) => {
    setSelectedGraph(value);
    setSelectedColumn('');
    setError(false);
  }

  const columnNameOnChange = async (evt, value) => {
    if (value == null) {
      return;
    }
    if (!selectedGraph) {
      setError(true);
      return;
    }
    setLoading(true);
    setSelectedColumn(value);
    const temp = [];
    temp.push(value);
    const data_sys = {
      "dtype": rawOrCleanData,
      "filename": actualFileName,
      "features": temp
    };
    try {
      const response = await fetchAPI.post('/features', data_sys, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
        }
      });
      setSelectedColumnData(response.data.data[value]);
    } catch (error) {
      console.error('Error uploading file:', error);
    } finally {
      setLoading(false);
    }
  }
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  };
  const headingStyle = {
    color: '#152C73',
    marginRight: '1rem',
    display: 'flex'
  };

  const graphContainerStyle = {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    width: '100%',
    marginTop: '2rem'
  };

  const graphStyle = {
    width: '100%',
    maxWidth: '920px',
    flex: '1 1 auto',
    border: '1px solid #ccc',
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.5rem', flexWrap: 'wrap' }}>
        <div style={{ width: '100%', display: 'flex', minWidth: '300px' }}>
          <h3 style={{ ...headingStyle, minWidth: '100px', textAlign: 'left' }}><b>Select Plot</b></h3>
          <Autocomplete
            id="combo-box-graph"
            options={allGraphs}
            style={{ display: 'flex', width: '250px' }}
            value={selectedGraph}
            autoHighlight={true}
            onChange={handleGraphSelection}
            renderInput={(params) => <TextField 
              {...params} 
              label={selectedGraph && selectedGraph.length > 0 ? "Selected Plot" : "Select the required plot"}
              error={error}
              helperText={error ? 'Please select required plot' : ''} 
            />}
          />
          <h3 style={{ ...headingStyle, marginLeft: '1rem', minWidth: '130px', textAlign: 'left' }}><b>Select Feature</b></h3>
          <Autocomplete
            id="combo-box-column"
            options={rawOrCleanData === "clean" ? numericalCleanedCols : numericalColumns}
            style={{ display: 'flex', width: '400px' }}
            value={selectedColumn}
            autoHighlight={true}
            onChange={columnNameOnChange}
            renderInput={(params) => <TextField
              {...params}
              label={selectedColumn && selectedColumn.length > 0 ? "Selected Feature" : "Select the required feature"}
            />}
          />
        </div>

      </div>
      <div style={graphContainerStyle}>
        {selectedColumn.length > 0 ? <div style={graphStyle}>
          {selectedGraph === "Histogram" && <Histogram data={selectedColumnData} />}
          {selectedGraph === "Strip Plot" && <StripPlot data={selectedColumnData} />}
          {selectedGraph === "Violin Plot" && <ViolinPlot data={selectedColumnData} />}
          {selectedGraph === "Box Plot" && <BoxPlot data={selectedColumnData} />}
        </div> : ""}

      </div>

      {loading && (
        <div style={overlayStyle}>
          <div className="loader"></div>
        </div>
      )}
    </>
  );
}

export default UnivariateAnalysisGraph;
